// Sep 2026 — shared timeline-filter helpers for the RM Inward tabs.
// Verbatim copy of the Feb 2026 helpers in `pages/RMInwardNoInvoice.js`
// (that screen is reference-only and deliberately untouched). The date
// filter narrows a date field on the backend using string-lex
// comparison; the selected preset just decides which `from`/`to` we
// hand over.
//
// NOTE: ESM exports — the production webpack build rejects named ESM
// imports from CommonJS modules. Jest coverage runs via `craco test`
// (babel transforms this file), NOT plain `npx jest`.

const DATE_MODES = { LAST_90: "last_90", MONTH: "month", RANGE: "range", ALL: "all" };
const _iso = (d) => d.toISOString().slice(0, 10); // YYYY-MM-DD

function defaultTimeline() {
  // Rolling last-90-days window ending today (inclusive).
  const today = new Date();
  const from = new Date(today);
  from.setDate(from.getDate() - 90);
  return {
    mode: DATE_MODES.LAST_90,
    month: _iso(today).slice(0, 7),   // YYYY-MM (for month picker)
    from: _iso(from),
    to: _iso(today),
  };
}

/** Compute {from, to} to hit the backend with (undefined = no bound).
 *  Returns YYYY-MM-DD strings. Month mode expands YYYY-MM to full
 *  first-day / last-day span. */
function resolveDateRange(tl) {
  if (!tl || tl.mode === DATE_MODES.ALL) return { from: undefined, to: undefined };
  if (tl.mode === DATE_MODES.LAST_90 || tl.mode === DATE_MODES.RANGE) {
    return { from: tl.from || undefined, to: tl.to || undefined };
  }
  if (tl.mode === DATE_MODES.MONTH && tl.month) {
    // Expand YYYY-MM into first and last day of that month.
    const [yStr, mStr] = tl.month.split("-");
    const y = parseInt(yStr, 10);
    const m = parseInt(mStr, 10);
    const first = new Date(Date.UTC(y, m - 1, 1));
    const last = new Date(Date.UTC(y, m, 0)); // day 0 of next month = last day of this month
    return { from: _iso(first), to: _iso(last) };
  }
  return { from: undefined, to: undefined };
}

/** Human-readable label of the current window — surfaced next to the
 *  filter row so users can never wonder "did old data disappear?". */
function describeTimeline(tl) {
  if (!tl || tl.mode === DATE_MODES.ALL) return "All time";
  if (tl.mode === DATE_MODES.LAST_90) return `Last 90 days (${tl.from} → ${tl.to})`;
  if (tl.mode === DATE_MODES.MONTH) return tl.month ? `Month: ${tl.month}` : "Month";
  if (tl.mode === DATE_MODES.RANGE) return `${tl.from || "…"} → ${tl.to || "…"}`;
  return "All time";
}

export { DATE_MODES, defaultTimeline, resolveDateRange, describeTimeline };
